import cache from './cache';
// import messages from '@intlify/unplugin-vue-i18n/messages';
export const messages = ['ar', 'de', 'en', 'es', 'fr', 'id', 'it', 'nl', 'pl', 'pt', 'ro', 'ja', 'ko'];

// 获取语言
export const getLanguage = () => {
  return cache.local.get(VITE_LANGUAGE) || 'en';
};
// 设置语言
export const setLanguage = (lang: string) => {
  cache.local.set(VITE_LANGUAGE, lang);
};
// 移除语言
export const removeLanguage = () => {
  cache.local.remove(VITE_LANGUAGE);
};

// 全量 语言标识符
export const languages = messages;

// 获取返回 路由语言标识符
export const getLanguageSign = (path?: string) => {
  const regex = new RegExp(`^/(${languages.join('|')})(?:/|$)`);
  path = path || window.location.pathname;
  const match = path.match(regex);
  return match ? match[1] : 'en';
};

// 获取不带语言标识的路由路径
// export const getNoSignPath = () => {
//   const regex = new RegExp(`^/(${languages.join('|')})(/.*)`);
//   const regexPath = new RegExp(`^/(${languages.join('|')})(/.*)?$`);
//   const match = location.pathname.toLocaleLowerCase().match(regexPath); //是否有 语言标识
//   const path = location.pathname.toLocaleLowerCase().replace(regex, '$2'); // 过滤语言标识 只要path路径
//   let pathName = ['/', '/en'].includes(path) || (match && !match[2]) ? '' : path;
//   let language = match && match[1] !== 'en' ? `/${match[1]}` : '';
//   return {
//     path: pathName,
//     language: language
//   };
// };

export const getNoSignPath = (path: string = location.pathname.toLocaleLowerCase()) => {
  const regex = new RegExp(`^/(${languages.join('|')})(/.*)`);
  const regexPath = new RegExp(`^/(${languages.join('|')})(/.*)?$`);
  const match = path.match(regexPath); //是否有 语言标识
  const url = path.replace(regex, '$2'); // 过滤语言标识 只要path路径
  let pathName = ['/', '/en'].includes(url) || (match && !match[2]) ? '' : url;
  let language = match && match[1] !== 'en' ? `/${match[1]}` : '';
  return {
    path: pathName,
    language: language
  };
};
